import { render, staticRenderFns } from "./addtocart.vue?vue&type=template&id=2b7465cf"
import script from "./addtocart.vue?vue&type=script&lang=js"
export * from "./addtocart.vue?vue&type=script&lang=js"
import style0 from "./addtocart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports